module.exports = __webpack_public_path__ + "img/1200px-St_Mirren_FC_logo.svg.1a63660f.png";